import React from 'react';

import AttachFile from '@material-ui/icons/AttachFile';
import Mail from '@material-ui/icons/Mail';
import Done from '@material-ui/icons/Done';
import DoneAll from '@material-ui/icons/DoneAll';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';

import LinearProgress from '@material-ui/core/LinearProgress';

import ProtectedImg from './ProtectedImg';

import { get } from '../../../api/_basic';

class AnswerSee extends React.Component {

    state = {
        expand: true,
        message: undefined,
        isLoading: false
    }

    static getDerivedStateFromProps(props, state) {
        if (props.info !== state.info) {
            state.info = props.info;
            return state;
        }
        return null;
    }


    handleExpand = (event) => {
        this.setState({ expand: !this.state.expand })
    }

    handleShow = (event) => {
        const { info } = this.props;
        const { message } = this.state;
        if (info && info.estado >= 2) {
            this.setState({ expand: true });
            if (!message && info.idRespuesta) {
                this.loadInfoMessage(info.idRespuesta);
            }
        }
    }

    loadInfoMessage = (message) => {
        this.setState({ isLoading: true });
        get(`${process.env.REACT_APP_API_MESSAGES}/${message}`)
            .then((response) => {
                this.setState({ isLoading: false });
                if (response.error !== undefined) {
                    this.props.showError(response.error);
                }
                return response;
            })
            .then((item) => {
                console.log(item);
                this.setState({ message: item });
            })
            .catch((error) => {
                this.setState({ isLoading: false });
                this.props.showError(error.message, error.type);
            });
    }

    render() {
        const { intl } = this.props;
        const { info, expand, isLoading, message } = this.state;

        return (
            <div className="flex_auto_column">
                <div className="flex_auto_row align_center shadow_down_only margin_left_18 margin_top_12 hand"  >

                    {info.estado === 0 &&
                        <Done className="c_disabled" />
                    }
                    {info.estado === 1 &&
                        <Done className="c_bluish" />
                    }
                    {info.estado >= 2 &&
                        <DoneAll className="c_pea" />
                    }
                    <Mail className={"margin_left_6 margin_right_6 " + (info.aviso ? "c_bluish" : "c_disabled")} />
                    <span className={"flex_full_row barlow_regular_small margin_right_24 " + (!info.pendiente ? "c_state" : "c_lipstick")} onClick={this.handleShow} >
                        {info.usuario}
                    </span>
                    {(expand && info.estado >= 2) && <ExpandLess className="c_state" onClick={this.handleExpand} />}
                    {(!expand && info.estado >= 2) && <ExpandMore className="c_state" onClick={this.handleExpand} />}
                </div>

                {expand &&
                    <div className="flex_auto_column margin_left_18 margin_top_12">
                        {isLoading && (
                            <LinearProgress color="secondary" />
                        )}
                        {(message && (!message.respuesta && message.adjuntos.length === 0)) && (
                            <div className="flex_full_row boxBorderForm center bg_lipstickligth c_lipstick">
                                {intl.formatMessage({ id: 'communications_no_answer' })}
                            </div>
                        )}
                        {(message && (message.respuesta || message.adjuntos.length > 0)) && (
                            <div className="flex_auto_column">
                                <div className="flex_auto_column margin_top_8">
                                    <div
                                        className="flex_full_row bg_black_6 shadow_left_only  ql-editor-show margin_left_32"
                                        dangerouslySetInnerHTML={{ __html: message.respuesta }}
                                    ></div>
                                </div>
                                <div className="flex_auto_column margin_top_8 margin_left_32">
                                    <div className="flex_auto_row align_center">
                                        <AttachFile className="c_disabled margin_right_2 communications_icon" />
                                        <p className="flex_full_row barlow_regular_small c_slate">
                                            {intl.formatMessage({ id: 'attach' })}
                                        </p>
                                    </div>
                                    {message.adjuntos.length > 0 &&
                                        message.adjuntos.map((a) => {
                                            return (
                                                <ProtectedImg
                                                    {...this.props}
                                                    key={`thumbnail-${message.id}-${a.id}`}
                                                    communication={false}
                                                    id={a.id}
                                                    name={a.nombre}
                                                    parent={message.id}
                                                    src={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/miniatura?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                    download={`${process.env.REACT_APP_API_MESSAGES}/${message.id}/adjunto/${a.id}/datos?token=${sessionStorage.token.replace('Bearer ', '')}`}
                                                />)
                                        })
                                    }
                                </div>
                            </div>
                        )}
                    </div>
                }
            </div>
        );
    }
}

export default AnswerSee;


// WEBPACK FOOTER //
// ./src/components/complex/communications/AnswerSee.js